import { Controller } from '@hotwired/stimulus';

// Counts down against a wall-clock target (not by decrementing on each tick)
// so the timer stays accurate under interval drift and background-tab
// throttling — mirrors the React styleguide TimerButton.
const TICK_MS = 250;

export default class extends Controller {
  static values = {
    seconds: Number,
    label: String,
  };

  connect() {
    this.targetAt = Date.now() + Math.max(0, this.secondsValue) * 1000;
    this.renderedSeconds = null;
    this.update();
    if (this.remaining() > 0) {
      this.interval = setInterval(() => this.update(), TICK_MS);
    }
  }

  disconnect() {
    this.stop();
  }

  update() {
    const remaining = this.remaining();

    if (remaining <= 0) {
      this.stop();
      this.complete();
      return;
    }

    this.render(remaining);
  }

  remaining() {
    return Math.max(0, Math.ceil((this.targetAt - Date.now()) / 1000));
  }

  render(remaining) {
    if (remaining === this.renderedSeconds) return;

    this.renderedSeconds = remaining;
    this.setText(`${this.labelValue} (${remaining}s)`);
  }

  complete() {
    this.element.removeAttribute('disabled');
    this.element.removeAttribute('aria-disabled');
    this.setText(this.labelValue);
    this.dispatch('complete');
  }

  stop() {
    if (this.interval) {
      clearInterval(this.interval);
      this.interval = null;
    }
  }

  setText(text) {
    const el = this.element.querySelector('.ui-button__text');
    if (el) {
      el.textContent = text;
    }
  }
}
